// NPF-nudge-flaggor (Pipeline 3: igångsättningsstöd + övergångsförvarning).
// Speglar childMode.ts exakt: lagras i localStorage, default PÅ. Efter setItem
// dispatchas 'storage' manuellt eftersom webbläsaren annars bara fyrar eventet i
// andra flikar, inte i den flik som gjorde ändringen — utan detta reagerar inte
// vyn förrän efter en omladdning. Default-på: ett saknat värde tolkas som på,
// endast den explicita strängen 'off' stänger av.
const NEXT_UP_KEY = 'nextUpEnabled';
const TRANSITION_WARNING_KEY = 'transitionWarningEnabled';

export const isNextUpEnabled = (): boolean => localStorage.getItem(NEXT_UP_KEY) !== 'off';

export const setNextUpEnabled = (on: boolean): void => {
  localStorage.setItem(NEXT_UP_KEY, on ? 'on' : 'off');
  window.dispatchEvent(new Event('storage'));
};

export const isTransitionWarningEnabled = (): boolean =>
  localStorage.getItem(TRANSITION_WARNING_KEY) !== 'off';

export const setTransitionWarningEnabled = (on: boolean): void => {
  localStorage.setItem(TRANSITION_WARNING_KEY, on ? 'on' : 'off');
  window.dispatchEvent(new Event('storage'));
};
